import React from "react";
import { SEARCH } from "../../../core/theme/searchTheme";
import { sampleTimesText, finishText, MINUTE_SPACING_WARNING_ABOVE, MINUTE_WARNING } from "../../../core/data/scanPlan";

// Bottom of the setup column, always visible: report name, search count,
// the sample plan, warnings (postcode limit, one-minute spacing), and the Run button.
export default function ScanSummary({ form, plan, now, running, onRun }) {
  const k = form.keywords.length;
  const p = plan.postcodes.length;
  const s = form.samples;

  return (
    <div className={SEARCH.summary}>
      <div className={SEARCH.summaryTop}>
        <span className={SEARCH.summaryName}>{plan.canRun ? plan.name : "New search"}</span>
        <span className={SEARCH.summaryCount}>{plan.total} searches</span>
      </div>
      <p className={SEARCH.summaryLine}>
        {k} keyword{k === 1 ? "" : "s"} × {p} postcode{p === 1 ? "" : "s"} × {s} sample{s === 1 ? "" : "s"} × mobile + desktop
        {plan.canRun && <> · samples at {sampleTimesText(plan.sampleTimes, form.spacing)} · done ~{finishText(now, plan.finish)}</>}
      </p>
      {plan.overLimit && (
        <p className={SEARCH.warning}>
          Too many postcodes: {p} — your account can search up to {plan.maxPostcodes} per search. Remove some to run it.
        </p>
      )}
      {plan.warning && (
        <p className={SEARCH.warning} title={`${plan.perSample} searches per sample; about ${MINUTE_SPACING_WARNING_ABOVE} fit in a minute`}>
          {MINUTE_WARNING}
        </p>
      )}
      <button className={SEARCH.runButton} disabled={!plan.canRun || running} onClick={onRun}>
        {running ? "Starting..." : "Start search"}
      </button>
    </div>
  );
}
